import { StyledLogo, SmallLogo } from "./styles";

export function Logo({ name, size = "normal" }) {
  let Component = StyledLogo;
  if (size === "small") Component = SmallLogo;
  return <Component href="/">{name}</Component>;
}